import styled from "styled-components";

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
  margin-left: 10px;
`;

export const LoadingStatus = styled.span`
  font-size: 15px;
  animation: fadeSlide 0.4s ease both;

  @keyframes fadeSlide {
    from { opacity: 0; transform: translateY(6px); }
    to   { opacity: 1; transform: translateY(0); }
  }
`;

export const Logo = styled.img`
  width: 20px;
  height: 20px;
`;
